import React, {useEffect, useState} from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import FsLightbox from "fslightbox-react";
import {getFileTypeImageByMimeType} from "../../mijn-portal/js/reacthelpers";
import Lang from "lang.js";
import messages from "../messages";

const lang = new Lang({messages, fallback: "nl"});
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/pro-solid-svg-icons/faLock";
import {faLockOpen} from "@fortawesome/pro-solid-svg-icons/faLockOpen";
import Swal from "sweetalert2";
import axios from "axios";

const Documentation = (props) => {

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(doc, index) {
        if (doc.restricted && !doc.url) {
            return unlockDocumentation(doc);
        }

        if (window.innerWidth < 650) {
            window.open(document.url, "_blank");
            return;
        }

        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: index + 1,
        });
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const docId = params.get('document_id');
        if (docId) {
            const index = props.documentation.findIndex(d => String(d.id) === docId);
            const doc = props.documentation[index];
            if (index !== -1 && doc) {
                openLightboxOnSlide(doc, index);
                // schoon URL zonder reload
                const url = new URL(window.location.href);
                url.searchParams.delete('document_id');
                window.history.replaceState({}, '', url.toString());
            }
        }
    }, [props.documentation]);

    async function handleDownload(e, doc) {
        const {url, name} = doc
        e.stopPropagation();
        e.preventDefault();
        if (doc.restricted && !doc.url) {
            return unlockDocumentation(doc);
        }
        try {
            const response = await fetch(url, {mode: "cors"});
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = name || "download";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(link.href);
        } catch (err) {
            console.error("Download failed:", err);
            window.open(url, "_blank"); // fallback
        }
    }

    async function unlockDocumentation(doc) {
        const { value: dto } = await Swal.fire({
            title: lang.get('sites.password_required'),
            html: lang.get('sites.documentation_restricted_text', {
                email: props.customerEmail, phone: props.customerPhone
            }),
            input: 'text',
            inputPlaceholder: lang.get('sites.restricted_site_enter_password'),
            showCancelButton: true,
            confirmButtonText: lang.get('sites.continue'),
            cancelButtonText: lang.get('portal.cancel'),
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary mr-2',
                cancelButton: 'btn btn-secondary',
                input: 'form-control',
                validationMessage: 'invalid-feedback d-block'
            },
            loaderHtml: '<span class="spinner-border spinner-border-sm"></span>',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),

            // Client-side verplicht veld
            inputValidator: (value) => {
                if (!value) return lang.get('sites.restrict_pass_verify');
            },

            // Server-side check (async)
            preConfirm: async (password) => {
                try {
                    const { data } = await axios.post(
                        `/api/site/${props.siteID}/restricted-docs`,
                        { password }
                    );
                    // Geef data door aan .then(result)
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.set('document_id', doc.id);

                    window.location.href = currentUrl.toString();
                } catch (e) {
                    // Toon serverfout netjes in Swal
                    Swal.showValidationMessage(
                        e?.response?.data?.error ||
                        e?.response?.data?.message ||
                        lang.get('sites.restrict_pass_verify')
                    );
                    // Zorg dat de Promise resolved blijft zodat Swal open blijft
                    return false;
                }
            }
        });

    }

    return (
        <>
            <style>
                {`
                .main-column-right {
                    z-index: unset !important;
                }

                .card {
                    background-color: transparent;
                }
                `}
            </style>
            <ul className="list-group">
                {props.documentation.map((doc, index) => {
                    return (
                        <li key={doc.id || index}
                            className="list-group-item list-group-item-action cursor-pointer h-100"
                            style={{height: '70px'}}
                            onClick={() => {
                                openLightboxOnSlide(doc, index)
                            }}>
                            <div className="row no-gutters align-items-center">
                                <div className="col-3 col-sm-1 pr-2 d-flex align-items-center p-0"
                                     style={{maxHeight: '50px', maxWidth: '50px'}}>
                                    {(doc.mime_type.includes("image/")) ?
                                        <img className="img-fluid rounded" src={doc.thumb} alt={doc.name}/>
                                        :
                                        <img className="img-fluid" src={getFileTypeImageByMimeType(doc.mime_type)}
                                             alt={doc.mime_type}/>
                                    }
                                </div>
                                <div className="col align-items-center">
                                    <div
                                        className="mb-0 text-truncate font-weight-bold align-items-center">{doc.name}</div>
                                </div>
                                <div className="col-auto pl-2 align-items-center text-right">
                                    {(doc.restricted) === true &&
                                        <FontAwesomeIcon icon={!doc.url ? faLock : faLockOpen} size="lg" className="mr-3"/>
                                    }

                                    <div
                                        className="btn btn-outline-secondary btn-sm"
                                    >
                                        {lang.get('portal.view')}
                                    </div>

                                    {!!doc.url &&
                                        <a
                                            className="btn btn-outline-secondary btn-sm ml-2"
                                            title="Download"
                                            href={doc.url}
                                            onClick={(e) => handleDownload(e, doc)}
                                        >
                                            Download
                                        </a>
                                    }
                                </div>
                            </div>
                        </li>
                    )
                })}
            </ul>

            <FsLightbox
                toggler={lightboxController.toggler}
                sources={[...props.documentation].map((document, index) => {
                    if (document.mime_type === 'application/pdf') {
                        return <embed key={index} src={document.url} width="2560px"
                                      height="1440px"/>
                    }
                    return document.url
                })}
                slide={lightboxController.slide}
                key={props.documentation.length}
                onClose={props.onClose}
                allowFullScreen={false}
            />
        </>)
}

export default HeaderFooterHOC(Documentation, 'documentation');
